// @flow

import { observer } from "mobx-react";
import React from "react";

import "./WizardTimelineItem.scss";

type Props = {};

@observer
export default class WizardTimelineItem extends React.Component<Props> {
    render() {
        return (
            <div className="WizardTimelineItem">
                <div className="WizardTimelineItem__icon">
                    <i className="fa fa-arrows-h" />
                </div>

                <div className="WizardTimelineItem__text">Drag</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineItem/WizardTimelineItem/WizardTimelineItem.js